import { getRequest } from 'tfs.front-end-utils/requests'

import ClientSSRInterface from '../../interfaces/client/SSR'
import ServerSSRTranslationInterface from '../../interfaces/server/SSRTranslation'

import staticData from '../../config/staticData'

import formatErrors from '../../utils/errors/formatErrors'
import addTranslationsToSSRs from '../../utils/ssrs/addTranslationsToSSRs'

interface TranslationsResponse {
  ssrs: ServerSSRTranslationInterface[]
}

export default async (
  nonTranslatedSSRs: ClientSSRInterface[]
): Promise<ClientSSRInterface[]> => {
  const {
    endpoints: {
      ssrsTranslations: {
        url: ssrsTranslationsUrl,
        headers: ssrsTranslationsHeaders,
      },
    },
  } = staticData

  try {
    const translations: TranslationsResponse = await getRequest(
      ssrsTranslationsUrl,
      { ssrsTranslationsHeaders },
      { setAuthorizationHeaders: false },
      formatErrors
    )

    const { ssrs = [] } = translations

    if (!ssrs.length) return []

    return addTranslationsToSSRs(nonTranslatedSSRs, ssrs)
  } catch (e) {
    return []
  }
}
